<template>
  <div>
    <v-form class="join-developer__form-col">
      <h5 class="join-developer__form-label">Preferences (optional)</h5>
      <v-row class="join-developer__row">
        <v-col class="join-developer__col">
          <v-select
            v-model="newDeveloper.technologies"
            class="form-field"
            :items="featuresData.technologies"
            dense
            multiple
            item-color="blue"
            label="Technology preferences"
            placeholder="Technology preferences"
          />
        </v-col>
      </v-row>
      <v-row class="join-developer__row">
        <v-col class="join-developer__col">
          <v-select
            v-model="newDeveloper.project_areas"
            class="form-field"
            :items="featuresData.project_areas"
            dense
            multiple
            item-color="blue"
            label="Project Area Preferences"
            placeholder="Choose type"
          />
        </v-col>
      </v-row>
      <v-row class="join-developer__row">
        <v-col class="join-developer__col">
          <v-select
            v-model="newDeveloper.hobbies"
            class="form-field"
            :items="featuresData.hobbies"
            dense
            multiple
            item-color="blue"
            label="Hobby"
            placeholder="Choose type"
          />
        </v-col>
      </v-row>
      <h5 class="join-developer__form-label">Description (optional)</h5>
      <v-row class="join-developer__row">
        <v-col class="join-developer__col">
          <v-textarea
          v-model="newDeveloper.description"
          flat
          solo
          outlined
          auto-grow
          color="blue-light"
          height="200px"
          hide-details
          placeholder="Additional informations..."
          class="issue-messages__textarea"
        />
        </v-col>
      </v-row>
      <v-row class="join-developer__row">
        <v-col class="join-developer__col">
          <v-btn
            color="blue"
            class="join-developer__btn white--text"
            large
            width="50%"
            @click="submitStep">
            NEXT STEP
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      newDeveloper: {
        technologies: [],
        project_areas: [],
        hobbies: [],
        description: '',
      },
    };
  },
  computed: {
    ...mapState('features', [
      'featuresData',
    ]),
  },

  methods: {
    ...mapActions('developer', [
      'addDeveloperData',
    ]),

    submitStep() {
      this.addDeveloperData(this.newDeveloper);
      this.$emit('submit');
    },
  },
};
</script>

<style>

</style>
